<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="item row row_ai_center">
                <app-filter-btn [activeFiltersCount]="activeFiltersCount"
                    [activeFiltersVisible]="activeFiltersVisible"></app-filter-btn>
            </div>
            <app-filter (changeActiveFiltersCount)="changeActiveFiltersCount()"
                (activeFiltersCountVisible)="onActiveFiltersVisible($event)" (applyFilter)="onFilterApply($event)"
                (resetFilter)="onFilterReset()" [filterData]="subscriptionsFilter" *ngIf="activeFilter">
                <app-filter-account [subscriptionsFilter]="subscriptionsFilter"></app-filter-account>
            </app-filter>
        </div>
        <app-table (modalProlong)="getSubscriptions()" prolong="prolong" [dataMissing]="dataMissing" [data]="subscriptions" [columns]="columns" [pagination]="{
                currentPage: currentPage,
                pageSize: pageSize,
                totalItems: totalItems
            }" (pageChange)="onPageChange($event)"><app-skeleton *ngIf="isLoading" height="40" margin="15"
                count="12"></app-skeleton></app-table>
    </div>
</div>
<app-toastr></app-toastr>